export default __webpack_public_path__ + "static/media/banner-img-1.db155e61.png";